<script>
	import { dev } from '$app/environment';
	import { injectAnalytics } from '@vercel/analytics/sveltekit';
	import { page } from '$app/stores';
  	$: canonicalUrl = 'https://www.jimbaranconventioncenter.com' + $page.url.pathname;
	
	injectAnalytics({ mode: dev ? 'development' : 'production' });
</script>

<svelte:head>
  <link rel="canonical" href="{canonicalUrl}" />
</svelte:head>

<main>
	<slot/>
</main>